export function isNativeRuntime() {
  if (typeof window === 'undefined') return false;
  const hasCapacitorObject = Boolean(window.Capacitor);
  const protocol = window.location?.protocol || '';
  return hasCapacitorObject || protocol === 'capacitor:' || protocol === 'ionic:';
}

